/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_COMPONENT_GROUPING_BY_SWATCH](state, {group, componentName, swatchId}){
    state.componentGroups = {
      ...state.componentGroups,
      [componentName]: {
        ...state.componentGroups[componentName],
        [swatchId]: group
      }
    }
  },
  [types.SET_COMPONENT_PARENT_CHILD_CONFIGURATION](state, { parentComponent, componentGroup }) {
    state.componentsParentChildConfiguration[parentComponent] = [ ...componentGroup ];
  },
};
export default mutations;